import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Fade } from 'react-awesome-reveal'

class About extends Component {
  render() {
    let lanaData = this.props.lanaData
    var { aClass } = this.props
    return (
      <section className={`${aClass}`} id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 d-flex align-items-center">
              <Fade direction="up" triggerOnce="true" damping={0.1}>
                <div className="about_content">
                  <h2 className="t_color">{lanaData.aboutme}</h2>
                  <h6>{lanaData.role}</h6>
                  <p>{lanaData.aboutdetails}</p>
                  <Link to="/" className="theme_btn active">
                    Nos travaux
                  </Link>
                  <Link to="/" className="theme_btn">
                    Télécharger le statut
                  </Link>
                </div>
              </Fade>
            </div>
            <div className="col-lg-5">
              <div className="about_img">
                <Fade direction="right" duration={1500}>
                  <img src={require('../image/apporoach_man_img.png')} alt="" />
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
export default About
